import React from "react";

import Pagination from "@material-ui/lab/Pagination";
import PropTypes from "prop-types";

import useRbPaginationStyles from "./useRbPaginationStyles";

const RbPagination = React.forwardRef(function RbPagination(props, ref) {
  const { align, ...other } = props;

  const classes = useRbPaginationStyles(props);

  return <Pagination {...other} ref={ref} classes={classes} />;
});

RbPagination.propTypes = {
  /**
   * Align the pagination horizontally
   */
  align: PropTypes.oneOf(["left", "center", "right"]),
};

RbPagination.defaultProps = {
  align: "center",
};

export default React.memo(RbPagination);
